module.exports = __webpack_public_path__ + "img/training_program_2.c6f3a538.jpg";